// 通配懒加载会收集 views 下所有模块，导航设计器、布局图标及文件句柄存储只供开发环境使用。
module.exports = file => () => import(/* webpackExclude: /(?:NavigationEditor|NavigationLayoutIcon)\.vue$|navigation-file\.js$/ */ '@/views/' + file)
